import React from 'react';

import { DeleteItemPopover } from '~components/generic/DeleteItemPopover/DeleteItemPopover';
import { TrashIcon } from '~components/icons/TrashIcon';
import styles from './Item.module.css';

interface ItemProps {
  file: any;
  onDelete: () => void;
}

const Item: React.FC<ItemProps> = ({ onDelete, file }) => {
  return (
    <div className={styles.itemContainer}>
      <span>
        {`${file.relationType && file.relationType}: `} {file.fileName ? file.fileName : file.name}
      </span>
      <DeleteItemPopover icon={<TrashIcon />} onDelete={onDelete} />
    </div>
  );
};

export default Item;
